<template>
    <div>
        <modal
        class="new-modal-default medium-modal create-configure-shift-work"
        transition="nice-modal-fade"
        :name="modal_name" 
        :delay="100" 
        height="auto"
        :width="400"
        :adaptive="true" :scrollable="true"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title text-white" >Add Contact List</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideModal"></span>
                    </div>
                </div>
                <div class="v-modal-body" style="height: 480px;">
                    <div class="v-modal-layout">
                        <!-- <div  v-if="ajax_call_in_progress">
                            <div class="position-relative">
                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                            </div>
                        </div>
                        <div v-else-if="!ajax_call_in_progress && list_data.length == 0" class="my-5">
                            <div class="fs-14 text-black text-center my-4">
                                No Contacts Yet
                            </div>
                        </div> -->
                        <!-- <div v-else> -->
                        <div >
                            <div class="position-sticky bg-white pt-3 pb-1" style="top: 0px; z-index: 5;">
                                <div class="w-100 ml-2 position-relative">
                                    <span>
                                        <i class="icon icon-magnify align-position fs-18"></i>
                                    </span>
                                    <input type="text" class="search_input w-100" v-model="search_key" @input="searchData" placeholder="Search by Contact Name, department, phone number" />
                                </div>
                            </div>
                            <div class="table-content mb-3 new-popup-table pt-3" style="overflow-x: auto !important;">
                                <table class="table table-content-data table-responsive">
                                    <thead class="w-100">
                                        <tr class="w-100">
                                            <th class="whiteSpace w-1">
                                                <el-checkbox ></el-checkbox>
                                            </th>
                                            <th class="whiteSpace w-1">
                                                Contact Name
                                            </th>
                                            <th class="whiteSpace w-1">
                                                Department
                                            </th>
                                            <th class="whiteSpace w-1">
                                                Phone Number
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="w-100">
                                        <!-- <tr class="w-100" v-for="(contact, index) in list_data" :key="index+'content'"> -->
                                        <tr class="w-100">
                                            <td colspan="4" class="whiteSpace w-100 p-0">
                                                <table cellpadding="0" cellspacing="0" width="100%">
                                                    <!-- <tr v-for="(contact_inner, contact_inner_index) in contact.contact" :key="contact_inner_index+'contact_inner_index'"> -->
                                                    <tr >
                                                        <td class="whiteSpace w-1" style="padding: 6.5px 10px;">
                                                            <el-checkbox ></el-checkbox>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            Ram Prasad
                                                        </td>
                                                        <td class="whiteSpace w-1" style="min-width:120px;">
                                                            <span class="ml-3">
                                                                Maintenance
                                                            </span>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            +91 7896541230
                                                        </td>
                                                    </tr>
                                                    <tr >
                                                        <td class="whiteSpace w-1" style="padding: 6.5px 10px;">
                                                            <el-checkbox ></el-checkbox>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            Ram Prasad
                                                        </td>
                                                        <td class="whiteSpace w-1" style="min-width:120px;">
                                                            <span class="ml-3">
                                                                Maintenance
                                                            </span>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            +91 7896541230
                                                        </td>
                                                    </tr>
                                                    <tr >
                                                        <td class="whiteSpace w-1" style="padding: 6.5px 10px;">
                                                            <el-checkbox ></el-checkbox>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            Ram Prasad
                                                        </td>
                                                        <td class="whiteSpace w-1" style="min-width:120px;">
                                                            <span class="ml-3">
                                                                Maintenance
                                                            </span>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            +91 7896541230
                                                        </td>
                                                    </tr>
                                                    <tr >
                                                        <td class="whiteSpace w-1" style="padding: 6.5px 10px;">
                                                            <el-checkbox ></el-checkbox>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            Ram Prasad
                                                        </td>
                                                        <td class="whiteSpace w-1" style="min-width:120px;">
                                                            <span class="ml-3">
                                                                Maintenance
                                                            </span>
                                                        </td>
                                                        <td class="whiteSpace w-1" >
                                                            +91 7896541230
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="v-modal-dialog-actions">
                    <div class="d-flex justify-content-center align-items-center">
                        <button class="btn btn-danger bord-rad-18px btn-smm mr-3" @click="hideModal">CANCEL</button>
                        <button class="btn btn-green btn-smm ml-3" :disabled="is_api_calling" >SAVE</button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import facility_mgmt from '../../mixins/facility_mgmt.js';
import moment from 'moment-timezone';
export default {
    props: ["modal_name"],
    components: {
        SweetModal
    },
    mixins: [facility_mgmt],
    data() {
        return {
            success_msg: '',
            warning_msg: '',
            search_key: '',
            list_data: [],
            ajax_call_in_progress: false,
            is_api_calling: false
        }
    },
    methods: {
        hideModal() {
            this.$emit('hideModal')
        },
        searchData() {
            this.fetchListData();
        },
        async fetchListData() {
            this.list_data = [];
            this.ajax_call_in_progress = true;
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key,
                };
                let response = await this.getEmergencyContactList(params);
                this.list_data = response.response.emergency_contact_details;
                this.ajax_call_in_progress = false;
            }
            catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                this.ajax_call_in_progress = false;
            }
        },
    },
    mounted() {
        this.fetchListData();
    },
    watch: {
        
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        create_data() {
            return {
                
            };
        },
    },
    created() {
        
    }
}
</script>
<style scoped>
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: solid 0.5px #00448b;
    }
    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }
</style>